import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import ToDo from "./ToDo";
import ToDoItem from "./ToDoItem";

export default class ToDoList extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'todo',
            data: null,
            loading: true,
            systemModuleId: 34,
            moduleAccessStatus: 1,
            menuId: 115
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.refreshData();
            });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <ToDo Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <ToDo Caller={this} /> });
    }
    onEditItem(id, toDoListId) {
        this.removeKeyDown();
        this.showComponents({
            component: <ToDoItem Caller={this} Id={id} ToDoListId={toDoListId} /> });
    }
    onAddItem(toDoListId) {
        this.removeKeyDown();
        this.showComponents({ component: <ToDoItem Caller={this} ToDoListId={toDoListId} /> });
    }
    setDone(id, done) {
        this.httpPost("api/v1/todo/item/done", {
            id,
            done
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div className="nk-content-body">
            {this.isEmpty(this.state.data.records) ? <div className="example-alert">
                <div className="alert alert-pro alert-warning">
                    <div className="alert-text"><h6>توجه</h6>
                        <p>برای شروع اولین یادداشت خود را اضافه نمایید</p>
                        <a className="btn btn-primary" onClick={e => this.onAdd()}>افزودن یادداشت جدید</a>
                    </div>
                </div>
            </div>
                : <div className="row">
                    <div className="col-sm-12">
                        <a className="btn btn-primary" onClick={e => this.onAdd()}>یادداشت جدید</a>
                    </div>
                    {this.state.data.records.map(todo => <div key={todo.id} className="col-sm-4 mt-4">
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px", maxHeight: "400px", backgroundColor: "white", "borderRadius": "4px", padding:"5px" }}>
                            <div style={{ display: "flex", flexDirection: "row", placeContent: "space-between", alignItems:"center" }}>
                                <a className="hand" onClick={e => this.onEdit(todo.id)}>{todo.title}</a>
                                <div>
                                    <a className="btn btn-sm btn-primary" onClick={e => this.onAddItem(todo.id)} title="ایجاد آیتم جدید">+</a>
                                </div>
                            </div>
                            {todo.items.map(item => <div style={{ display: "flex", flexDirection: "row", gap: "5px", borderTop: "solid 1px #e9e9e9" }}>
                                <input onChange={e => this.setDone(item.id, e.target.checked)} defaultChecked={item.done} type="checkbox" />
                                <a className="hand" onClick={e => this.onEditItem(item.id, todo.id)}>{item.title}</a>
                            </div>)}
                        </div>
                    </div>
                    )}
                </div>
            }
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.isEmpty(this.state.data.global.companies) ? [
                    <Header data={this.state.data} />,
                    <div className="nk-content ">
                        <div className="container-fluid">
                            <div className="nk-content-inner">
                                {this.renderNoCompanyRegister()}
                            </div>
                        </div>
                    </div>,
                    <Footer />
                ] : [
                    <Header data={this.state.data} />,
                    <div className="nk-content ">
                        <div className="container-fluid">
                            <div className="nk-content-inner">
                                {this.renderForm()}
                            </div>
                        </div>
                    </div>,
                    <Footer />
                ],
                this.renderPopupComponent(),
            ];

        return contents;
    }
}